import { apiV1 } from './api';

const getOrganisationList = (params) => apiV1.get('/organisations', { params });

const getOrganisation = (id, params) => apiV1.get(`/organisations/${id}`, { params });

export { getOrganisationList, getOrganisation };
